export default "__VITE_ASSET__uxn30Q05__"